import {
  tipologiaImpalcato,
  tipologiaSchema,
  tipologiaStrutturale,
} from 'constants/inspections';
import { tipologiaImpalcatoOptions } from 'constants/selectOptions';

// Tipologie impalcato sempre incompatibili con una data tipologia
// strutturale, indipendentemente da schema/campate/versione.
const STRUTTURA_ESCLUSIONI_BASE = {
  [tipologiaStrutturale.TravateAppoggiate]: [tipologiaImpalcato.Muratura],
  [tipologiaStrutturale.TravateContinueTelaio]: [tipologiaImpalcato.Muratura],
  [tipologiaStrutturale.StrallatoSospeso]: [tipologiaImpalcato.Muratura],
  [tipologiaStrutturale.ArcoMassiccio]: [
    tipologiaImpalcato.Acciaio,
    tipologiaImpalcato.Metallo,
    tipologiaImpalcato.Legno,
    tipologiaImpalcato.Misto,
  ],
  [tipologiaStrutturale.ArcoSottile]: [
    tipologiaImpalcato.Muratura,
    tipologiaImpalcato.Misto,
  ],
  [tipologiaStrutturale.SolettaAppoggiata]: [
    tipologiaImpalcato.Muratura,
    tipologiaImpalcato.Misto,
  ],
  [tipologiaStrutturale.SolettaIncastrata]: [
    tipologiaImpalcato.Muratura,
    tipologiaImpalcato.Misto,
  ],
  [tipologiaStrutturale.SezioneTubolare]: [
    tipologiaImpalcato.Muratura,
    tipologiaImpalcato.Misto,
  ],
  [tipologiaStrutturale.TravateGerberPontiStampella]: [
    tipologiaImpalcato.Muratura,
    tipologiaImpalcato.Legno,
  ],
};

// Tipologie strutturali per cui è ammesso solo il C.A.P.
const STRUTTURE_SOLO_CAP = new Set([
  tipologiaStrutturale.CassonePrecompresso,
  tipologiaStrutturale.TravateCap,
]);

/**
 * Opzioni di "tipologia impalcato" ammesse per la combinazione corrente di
 * tipologia strutturale / schema statico / numero campate / versione.
 * Due invarianti applicate sempre, a prescindere dalla tipologia strutturale:
 * - Muratura + Schema Isostatico: cella non definita nella matrice CDA 4.13
 *   (apps/api InspectionExtensions.getCdaFrom4_13Matrix) -> mai selezionabile
 * - C.A.P. + Schema Iperstatico a campata singola (v1): combinazione non
 *   costruttivamente prevista
 */
export const getOpzioniImpalcatoAmmesse = (
  watchTipologiaStrutturale,
  watchTipologiaSchema,
  nCampate,
  isVersion1
) => {
  if (!watchTipologiaStrutturale) {
    return tipologiaImpalcatoOptions;
  }

  const esclusioni = new Set();

  if (STRUTTURE_SOLO_CAP.has(watchTipologiaStrutturale)) {
    tipologiaImpalcatoOptions.forEach(o => {
      if (o.value !== tipologiaImpalcato.CAP) {
        esclusioni.add(o.value);
      }
    });
  } else {
    (STRUTTURA_ESCLUSIONI_BASE[watchTipologiaStrutturale] ?? []).forEach(v =>
      esclusioni.add(v)
    );
  }

  if (watchTipologiaSchema === tipologiaSchema.Isostatico) {
    esclusioni.add(tipologiaImpalcato.Muratura);
  }

  if (
    isVersion1 &&
    watchTipologiaSchema === tipologiaSchema.Iperstatico &&
    nCampate === 1
  ) {
    esclusioni.add(tipologiaImpalcato.CAP);
  }

  return tipologiaImpalcatoOptions.filter(o => !esclusioni.has(o.value));
};
